import { IRole } from 'shared/interfaces'
import { TSelectOption } from 'shared/types'
import { IUserForm, IAssignedProjectsItem } from './types'
import { UserCreate, Campaign } from 'shared/__gql-types'

export const userRoles = [
  { label: 'Label Manager', value: 'label_manager' },
  { label: 'Project Owner', value: 'campaign_owner' },
  { label: 'Author', value: 'author' },
  { label: 'Viewer', value: 'viewer' }
]

export const matchRoles = (roles: string) => roles.match(/promoter|Viewer|Brand Manager(External)?/gi)?.join(', ')

export const matchCampaigns = (campaigns: string) => campaigns.match(/\d+/g)

export const isDisabledByRole = (role: string, userRole?: string) =>
  (userRole === 'label-manager' && (role === 'admin' || role === 'global-manager')) ||
  (userRole === 'global-manager' && role === 'admin')

export const formatRolesToOptions = (roles: IRole[], isUserExternal: boolean, userRole?: string) =>
  roles.reduce((options: TSelectOption[], role: IRole) => {
    if ((isUserExternal && !role.can_assign_external) || isDisabledByRole(role.id, userRole)) {
      return options
    }
    return [
      ...options,
      {
        label: role.name,
        value: role.id
      }
    ]
  }, [])

export const formatOktaUserData = (values: IUserForm) => ({
  email: values.email,
  firstName: values.first_name,
  lastName: values.last_name
})

export const formatUserData = ({ all_campaign, assigned_campaigns, expire_at, ...values }: IUserForm, isUserExternal: boolean): UserCreate => {
  return {
    ...values,
    role: {
      role_id: values.role,
      ...(isUserExternal && expire_at && { expire_at: expire_at.toISOString() })
    },
    ...(values.label_id && { label_id: values.label_id }),
    ...(isUserExternal && {
      ...((!all_campaign && assigned_campaigns) && { assigned_campaigns: assigned_campaigns.map(({ projectId }) => projectId) })
    })
  }
}

export function userCampaignAdapter({ id, name, artist }: Campaign): IAssignedProjectsItem {
  return {
    projectId: id || '',
    projectName: name || '',
    artistName: artist?.name ?? '',
    spotifyId: artist?.spotify_id ?? '',
    facebookId: artist?.facebook_id ?? ''
  }
}
